import { Order } from '../../../store/order/api/interface'
import { newfDateTime } from '../../../utils/formatTime';

export function pos(data: Order[]) {
  const result = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    result.push({
      orderReference: `order/${element?.id}`,
      session: 'App/00000',
      date: newfDateTime(element?.orderDate),
      receiptNumber: element?.orderNumber,
      customer: `${element?.userDetails?.firstName} ${element?.userDetails?.lastName}`,
      employee: 'sami',
      total: parseFloat(Number(element?.totalAmount ?? 0).toFixed(2)),
      status: element?.payment?.paymentStatus === 'pending' ? 'pending' : 'paid',
    });
  }

  return result;
}